export const USER_DETAILS = "e45b3703-dad0-432d-a670-affde393af03";
export const ACCESS_TOKEN = "430149761-6ED2-421B-95E5-E1F272CB6247";
export const REFRESH_TOKEN = "8D10DKJ9-TY9B-4XOC-CQ54-A375EFCBI9X0";
export const STORE_LIST = "I12149761-a670-6ED2-TY9B-430149999";
export const SELECTED_STORE = "o232140061-a600-6E12-TH9B-87y141299";
export const ROLES = "0f5adcad-577f-4c27-a135-46b1d0383d34";
export const GENERAL = "61814401-fa8b-4559-b52b-434051e3fb5e";
export const SELECTED_MENU = "31811111-Aa8b-5559-v56b-554051e3go45"